export const storyParagraphs = [
  "A NXHOST nasceu em 2007 com um propósito simples e duradouro: ajudar empresas a estarem online com estabilidade, segurança e profissionalismo.",
  "Ao longo dos anos, acompanhamos a evolução da internet de perto. Começamos com hospedagem e infraestrutura e, com o tempo, ampliamos a atuação para sites, lojas virtuais, sistemas e soluções digitais personalizadas.",
  "Hoje, reunimos hospedagem, servidores e soluções web em um só lugar. Mais do que vender planos, trabalhamos para que a presença digital do seu negócio seja sólida e preparada para crescer.",
  "Seguimos evoluindo junto com as necessidades de quem confia na NXHOST — sempre com atendimento próximo e tecnologia de verdade.",
];

export const sobreStats = [
  { value: "2007", label: "Ano de início da NXHOST" },
  { value: "+19 anos", label: "De experiência em tecnologia" },
  { value: "BR", label: "Servidores no Brasil" },
  { value: "100%", label: "Foco em empresas" },
];

export const sobreValues = [
  {
    icon: "ri-shield-star-line",
    title: "Confiança",
    description: "Construímos relações duradouras, com transparência em tudo o que fazemos.",
  },
  {
    icon: "ri-cpu-line",
    title: "Tecnologia",
    description: "Investimos em estrutura e ferramentas para entregar resultados consistentes.",
  },
  {
    icon: "ri-signal-tower-line",
    title: "Estabilidade",
    description: "Buscamos manter o seu projeto online e funcionando de forma confiável.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Atendimento próximo",
    description: "Gente de verdade para ajudar quando você precisar.",
  },
  {
    icon: "ri-speed-up-line",
    title: "Desempenho",
    description: "Estruturas pensadas para entregar rapidez e boa experiência ao usuário.",
  },
  {
    icon: "ri-rocket-2-line",
    title: "Evolução contínua",
    description: "Acompanhamos as mudanças da internet para o seu negócio não ficar para trás.",
  },
];

export const sobrePositioning = [
  {
    icon: "ri-focus-3-line",
    title: "O que somos",
    description:
      "Uma empresa de tecnologia que oferece infraestrutura e soluções digitais para empresas que precisam estar online com segurança e desempenho.",
  },
  {
    icon: "ri-group-line",
    title: "Para quem trabalhamos",
    description:
      "Empresas de diferentes segmentos: corporativas, indústrias, distribuidores, prestadores de serviços, lojas virtuais e projetos personalizados.",
  },
  {
    icon: "ri-route-line",
    title: "Como atuamos",
    description:
      "Com atendimento próximo, tecnologia confiável e estruturas que crescem junto com o seu negócio, do site institucional à infraestrutura mais robusta.",
  },
];